import { ButtonHTMLAttributes, HTMLAttributes } from "react";

export function DropdownMenu({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            role="menu"
            className={`min-w-[220px] rounded-2xl border border-border bg-surface p-2
                shadow-float ${className}`}
            {...props}
        />
    );
}

interface DropdownItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    destructive?: boolean;
}

export function DropdownItem({ destructive = false, disabled = false, className = "", ...props }: DropdownItemProps) {
    return (
        <button
            role="menuitem"
            disabled={disabled}
            className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left font-sans text-sm
                transition-colors duration-150
                ${destructive ? "text-danger hover:bg-danger-subtle" : "text-ink hover:bg-surface-sunken"}
                disabled:opacity-40 disabled:pointer-events-none disabled:text-ink-faint ${className}`}
            {...props}
        />
    );
}

export function DropdownDivider() {
    return <div className="my-1 h-px bg-border" />;
}
